// Tishnotes brand marks. Ported from the design handoff bundle
// (claude.ai/design). The logomark is a note-card + highlighter glyph —
// literally "Tishnotes". Source SVGs live in src/assets/brand/.
//
// The glyph carries its own fixed brand palette (a logo should read the same
// on any surface), but the wordmark TEXT uses utility classes so it tracks the
// theme (ink/green ramps, dark-mode remap) like the rest of the UI.

/** The note-card + highlighter glyph, full color. */
export function Logomark({
  size = 28,
  className,
}: {
  size?: number;
  className?: string;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Tishnotes"
      className={className}
    >
      <rect width="64" height="64" rx="15" fill="#0F7D4E" />
      <rect x="0.5" y="0.5" width="63" height="63" rx="14.5" stroke="#000000" strokeOpacity="0.08" />
      <rect x="13" y="12" width="38" height="40" rx="6.5" fill="#FCFBF6" />
      <rect x="18" y="28.5" width="29" height="7.5" rx="3.75" fill="#F4D43C" />
      <rect x="20" y="20" width="22" height="3.4" rx="1.7" fill="#0F7D4E" />
      <rect x="20" y="30.6" width="24" height="3.4" rx="1.7" fill="#16352A" />
      <rect x="20" y="41.2" width="15" height="3.4" rx="1.7" fill="#0F7D4E" />
    </svg>
  );
}

/**
 * Full wordmark lockup: glyph + "Tishnotes", with "Tish" in ink, "notes" in
 * green under a marker swipe (design.md's one signature flourish). Rendered as
 * real text (not the SVG `<text>`) so the brand display font and the theme
 * apply.
 */
export function Wordmark({
  glyphSize = 28,
  className,
}: {
  glyphSize?: number;
  className?: string;
}) {
  return (
    <span className={`inline-flex items-center gap-2 ${className ?? ''}`}>
      <Logomark size={glyphSize} />
      <span className="font-display font-bold leading-none tracking-tight">
        <span className="text-slate-900">Tish</span>
        <span className="tn-mark text-green-700">notes</span>
      </span>
    </span>
  );
}
